import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../components/Loader";

function Getbookings() {
	const [loading, setloading] = useState(true);
	const [bookings, setbookings] = useState([]);
	const [error, seterror] = useState();

	useEffect(() => {
		try {
			axios
				.get("https://online-hotels-booking-system-server.vercel.app/api/bookings/getallbookings")
				.then((response) => {
					setbookings(response.data);
					setloading(false);
				});
		} catch (error) {
			seterror(true);

			setloading(false);
		}
	}, []);

	return (
		<div className="row">
			<div className="col-md-12">
				<h1>Bookings</h1>
				{loading && <Loader />}
			

				<table className="table table-bordered table-dark">
					<thead className="bs">
						<tr>
							<th>Booking ID</th>
							<th> User Name</th>
							<th> User ID</th>
							<th> Room</th>
							<th> Fom</th>
							<th> To</th>
							<th> Status</th>
						</tr>
					</thead>
					<tbody>
						{bookings.length &&
							bookings.map((booking) => {
								return (
									<tr>
										<td>{booking._id}</td>
										<td>{booking.userName}</td>
										<td>{booking.userid}</td>
										<td>{booking.room}</td>
										<td>{booking.fromdate}</td>
										<td>{booking.todate}</td>
										<td>{booking.status}</td>
									</tr>
								);
							})}
					</tbody>
				</table>
			</div>
		</div>
	);
}

export default Getbookings;
